<template>
  <div>
    <div class="content">
      <h4 class="content-subTitle">一、简介</h4>
      <p>Hi，您好，欢迎使用API开放平台。</p>
      <p>本文档主要针对平台开发者，描述快递服务技术对接平台的相关技术内容。如果您对文档内容有任何疑问，可以联系平台运营解答疑问。</p>
    </div>
    <div class="content">
      <h4 class="content-subTitle">二、版本更新记录</h4>
      <table cellspacing="0" cellpadding="0" border="0" class="content-table">
        <tr>
          <th>
            <div class="cell">日期</div>
          </th>
          <th>
            <div class="cell">版本号</div>
          </th>
          <th>
            <div class="cell">更新内容</div>
          </th>
        </tr>
        <tr>
          <td>
            <div class="cell">2021.01.01</div>
          </td>
          <td>
            <div class="cell">1.0.0</div>
          </td>
          <td>
            <div class="cell">提供了调用开放平台接口的通用标准，辅助完成接口的签名</div>
          </td>
        </tr>
      </table>
    </div>
    <div class="content">
      <h4 class="content-subTitle">三、快速入门 安装API开放平台 SDK</h4>
      <table cellspacing="0" cellpadding="0" border="0" class="content-table">
        <tr>
          <th>
            <div class="cell">语言</div>
          </th>
          <th>
            <div class="cell">最新版本</div>
          </th>
          <th>
            <div class="cell">项目示例</div>
          </th>
          <th>
            <div class="cell">开发环境</div>
          </th>
        </tr>
        <tr>
          <td>
            <div class="cell">JAVA</div>
          </td>
          <td>
            <div class="cell"><a href="https://ocms.bxexpress.com.cn/baw/openapi/jt-openapi-sdk.zip" download="">jt-openapi-sdk.zip</a></div>
          </td>
          <td>
            <div class="cell"><a href="https://ocms.bxexpress.com.cn/baw/openapi/%E9%A1%B9%E7%9B%AE%E7%A4%BA%E4%BE%8B.zip" download="">项目示例.zip</a></div>
          </td>
          <td>
            <div class="cell">支持 JAVA版本：1.8+</div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="cell">PHP</div>
          </td>
          <td>
            <div class="cell"></div>
          </td>
          <td>
            <div class="cell"><a href="https://ocms.bxexpress.com.cn/baw/openapi/PHP%E7%AD%BE%E5%90%8D%E7%A4%BA%E4%BE%8B.zip" download="">项目示例.zip</a></div>
          </td>
          <td>
            <div class="cell">支持 PHP7.0及以上</div>
          </td>
        </tr>
      </table>
    </div>
    <div class="content">
      <h4 class="content-subTitle">四、API-SDK目录结构</h4>
      <div class="pre_api jv-container">
        <pre class="jv-code"><code>com.yl.jms.sdk
├── auth //签名相关类
├──client //公用类
├──exception //异常相关类
├──http //Http通信相关类
└──JtExpressApi //开放平台api通用接口
└──JtExpressExecutor //执行器接口</code></pre>
      </div>
    </div>
    <div class="content">
      <h4 class="content-subTitle">五、直接使用JAR包步骤如下：</h4>
      <p>1.SDK压缩工具包由开放平台提供。</p>
      <p>2.将开放平台提供的`jt-openapi-sdk.zip`解压后，复制到工程文件夹中。</p>
      <p>3.点击 File -> Project Structure（快捷键 Ctrl + Alt + Shift + s），点击Project Structure界面左侧的“Modules。</p>
      <p>4.在 “Dependencies” 标签界面下，点击右边的 “+”号，选择第一个选项“JARs or directories...”，选择相应的jar包，点“OK”，jar包添加成功。</p>
      <p>5.具体接口的SDK调用方法可以下载‘示例实用项目.zip’进行参考。</p>
    </div>
    <div class="content">
      <h4 class="content-subTitle">六、SDK相关maven依赖</h4>
      <p>SDK默认使用slf4j-api包进行日志输出;SDK默认使用fastjson进行json数据转换；SDK默认使用httpclient进行http数据传输。</p>
      <div class="pre_api jv-container">
        <pre class="jv-code"><code>&lt;dependencies&gt;
    &lt;!-- https://mvnrepository.com/artifact/org.apache.commons/commons-lang3 --&gt;
    &lt;!--commons-lang3依赖版本不能低于3.9--&gt;
    &lt;dependency&gt;
        &lt;groupId&gt;org.apache.commons&lt;/groupId&gt;
        &lt;artifactId&gt;commons-lang3&lt;/artifactId&gt;
        &lt;version&gt;${version}&lt;/version&gt;
    &lt;/dependency&gt;
    &lt;!-- https://mvnrepository.com/artifact/org.slf4j/slf4j-api --&gt;
     &lt;!--slf4j-api依赖版本不能低于1.7.30--&gt;
    &lt;dependency&gt;
        &lt;groupId&gt;org.slf4j&lt;/groupId&gt;
        &lt;artifactId&gt;slf4j-api&lt;/artifactId&gt;
        &lt;version&gt;${version}&lt;/version&gt;
    &lt;/dependency&gt;
     &lt;!--fastjson依赖版本不能低于1.2.70--&gt;
    &lt;dependency&gt;
        &lt;groupId&gt;com.alibaba&lt;/groupId&gt;
        &lt;artifactId&gt;fastjson&lt;/artifactId&gt;
        &lt;version&gt;${version}&lt;/version&gt;
        &lt;scope&gt;compile&lt;/scope&gt;
    &lt;/dependency&gt;
     &lt;!--httpclient依赖版本不能低于4.4.1--&gt;
    &lt;dependency&gt;
        &lt;groupId&gt;org.apache.httpcomponents&lt;/groupId&gt;
        &lt;artifactId&gt;httpclient&lt;/artifactId&gt;
        &lt;version&gt;${version}&lt;/version&gt;
    &lt;/dependency&gt;
&lt;/dependencies&gt;</code></pre>
      </div>
    </div>
    <div class="content">
      <h4 class="content-subTitle">七、创建JtExpressApi</h4>
      <p>JtExpressApi是极兔开放平台api通用执行器,为使用极兔开放平台的开发人员提供了一系列的交互方法。</p>
      <p>用户可以参考如下代码新建一个JtExpressApi,初始化完成后建议单例使用,避免重复创建:</p>
      <div class="pre_api jv-container">
        <pre class="jv-code"><code>public class SdkTestDemo{
    public static final String apiAccount="api账号";
    public static final String privateKey="平台密钥";
    public static final String customerCode="协议客户账号";
    public static final String orderPassword="协议客户密码";
    //用户要调用的接口地址
    public static final String url = "http://test-openapi.bxexpress.com.cn/webopenplatformapi/api/location/getLocation";
    public static void main(String[] args) throws IOException {
        //创建授权用户实体
        ClientConfiguration clientConfiguration = new ClientConfiguration(apiAccount,privateKey);
        //当调用postByCustom方法时需要customerCode和orderPassword
        clientConfiguration.setCustomerCode(customerCode);
        clientConfiguration.setCustomerPwd(orderPassword);
        JtExpressApi jtExpressApi = new JtExpressApiOperator(clientConfiguration);
        //把接口需要的参数封装到map
        Map&lt;String, Object&gt; map = new HashMap&lt;&gt;();
        map.put("countryCode","CHN");
        //调用执行器,调用接口方法
        JSONObject location = jtExpressApi.post(map,url);
        System.out.println(location);
    }
}</code></pre>
      </div>
    </div>
    <div class="content">
      <h4 class="content-subTitle">八、建议</h4>
      <p>如果你是用springboot框架来调用API开放平台-SDK相关接口,建议把JtExpressApi放到spring容器中进行管理,</p>
      <p>用户可以参考如下代码新建一个配置类:</p>
      <div class="pre_api jv-container">
        <pre class="jv-code"><code>@Configuration
public class SdkDemoConfig {
    //api账号
    @Value("${apiAccount}")
    public String apiAccount;
    
    //平台密钥
    @Value("${privateKey}")
    public String privateKey;
    
    //协议客户账号
    @Value("${customerCode}")
    public String customerCode;
    
    //协议客户密码
    @Value("${orderPassword}")
    public String orderPassword;

    @Bean
    public JtExpressApi jtExpressApi(){
     //创建授权用户实体
        ClientConfiguration clientConfiguration = new ClientConfiguration(apiAccount,privateKey);
        //当调用postByCustom方法时需要customerCode和orderPassword
        clientConfiguration.setCustomerCode(customerCode);
        clientConfiguration.setCustomerPwd(orderPassword);
        JtExpressApi jtExpressApi = new JtExpressApiOperator(clientConfiguration);
        return jtExpressApi;
    }
}</code></pre>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "",
    data() {
      return {};
    },
    components: {},
  };
</script>

<style lang="scss" scoped>
  .content {
    margin-top: 30px;
    font-size: 14px;
    font-weight: 400;
    color: #61666d;
    line-height: 22px;
    .content-subTitle {
      height: 22px;
      font-size: 16px;
      font-weight: 600;
      color: #2b2d42;
      line-height: 22px;
      margin-bottom: 10px;
      &.bodySign {
        margin: 50px 0 10px;
      }
    }
    p {
      margin-top: 15px;
      word-break: break-all;
    }
  }
  .content-table {
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    flex: 1;
    width: 100%;
    max-width: 100%;
    background-color: #ffffff;
    font-size: 14px;
    color: #606266;
    border-radius: 4px;
    th,
    td {
      padding: 12px 0;
      min-width: 0;
      box-sizing: border-box;
      text-overflow: ellipsis;
      vertical-align: middle;
      position: relative;
      text-align: left;
      border-right: 1px solid #ebeef5;
      border-bottom: 1px solid #ebeef5;
      &:nth-child(1) {
        border-left: 1px solid #ebeef5;
      }
      .cell {
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        word-break: break-all;
        line-height: 23px;
        padding-left: 10px;
        padding-right: 10px;
      }
    }
    th {
      background-color: #f9fafc !important;
      border-top: 1px solid #ebeef5;
      font-weight: 400;
      color: #4c4d57;
    }
  }
  .pre_api {
    background: #f9fafc;
    border: 1px solid #dcdee1;
    border-radius: 4px;
    box-sizing: border-box;
    max-height: 400px;
    overflow: auto;
    margin-top: 15px;
    .jv-code {
      padding: 20px;
      margin: 0;
      width: 100%;
      box-sizing: border-box;
      white-space: pre-wrap;
      color: #525252;
      font-size: 14px;
      font-family: Consolas, Menlo, Courier, monospace;
    }
  }
</style>
